// extracted by mini-css-extract-plugin
export var button = "CtaWithTags-module--button--42a9b";
export var fadeInAnimation = "CtaWithTags-module--fadeInAnimation--f32db";
export var layout = "CtaWithTags-module--layout--6da7d";
export var subtitle = "CtaWithTags-module--subtitle--db069";
export var tagsLayout = "CtaWithTags-module--tagsLayout--56b3a";
export var tagsWrapper = "CtaWithTags-module--tagsWrapper--d5205";
export var titleWrapper = "CtaWithTags-module--titleWrapper--6a5df";